import React from "react";
import { get } from "lodash";
import PropTypes from "prop-types";

class Vuukle extends React.Component {
  render() {
    let story = get(this.props, ["story"]);
    return (
      <span>
        <div id={`vuukle-emote-${story.id}`} />
        <div id={`vuukle-comments-${story.id}`} />
        <div id={`vuukle-widget-${story.id}`} />
      </span>
    );
  }
}

Vuukle.propTypes = {
  story: PropTypes.object,
  vuukleConfig: PropTypes.object
};

export default Vuukle;
